var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreadmill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26367 35C4.69629 35 4.23828 34.542 4.23828 33.9746V32.1289C4.23828 31.5615 4.69629 31.1035 5.26367 31.1035C5.83105 31.1035 6.28906 31.5615 6.28906 32.1289V33.9746C6.28906 34.542 5.83105 35 5.26367 35Z",
    fill: "#596C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0098 35C29.4424 35 28.9844 34.542 28.9844 33.9746V32.1289C28.9844 31.5615 29.4424 31.1035 30.0098 31.1035C30.5771 31.1035 31.0352 31.5615 31.0352 32.1289V33.9746C31.0352 34.542 30.5771 35 30.0098 35Z",
    fill: "#3B4A51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.917 25.6552L29.8662 7.19821L24.7461 8.68161V25.7715L31.917 25.6552Z",
    fill: "#3B4A51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8984 24.7461C30.8574 24.7461 30.8096 24.7461 17.5 25.7236C13.7607 25.9971 8.97559 26.3526 2.85059 26.8037C1.25098 26.9268 0 28.2735 0 29.8731C0 31.5684 1.38086 32.9492 3.07617 32.9492H30.8984C33.1611 32.9492 35 31.1104 35 28.8477C35 26.585 33.1611 24.7461 30.8984 24.7461Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 28.8477C35 31.1104 33.1611 32.9492 30.8984 32.9492H17.5V25.7236C30.8096 24.7461 30.8574 24.7461 30.8984 24.7461C33.1611 24.7461 35 26.585 35 28.8477Z",
    fill: "#C7CFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9492 28.8477C32.9492 29.9756 32.0264 30.8985 30.8984 30.8985H3.07617C2.50879 30.8985 2.05078 30.4404 2.05078 29.8731C2.05078 29.3672 2.44727 28.9229 2.94629 28.8545H3.03516L3.11035 28.8408C9.07812 28.4033 13.7881 28.0547 17.5 27.7813C28.1777 26.9951 30.5771 26.8242 30.9463 26.7969C32.0537 26.8242 32.9492 27.7334 32.9492 28.8477Z",
    fill: "#596C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9492 28.8477C32.9492 29.9756 32.0264 30.8985 30.8984 30.8985H17.5V27.7813C28.1777 26.9951 30.5771 26.8242 30.9463 26.7969C32.0537 26.8242 32.9492 27.7334 32.9492 28.8477Z",
    fill: "#3B4A51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7498 9.68651C22.5721 9.14647 22.8592 8.56542 23.3992 8.38768L29.0594 6.50096L30.953 0.704087C31.1307 0.164048 31.7049 -0.129897 32.245 0.0478371C32.785 0.225571 33.0789 0.79979 32.9012 1.33983L30.8504 7.62889C30.7479 7.93651 30.5086 8.1826 30.201 8.28514L24.0487 10.3359C23.5086 10.5205 22.9276 10.2265 22.7498 9.68651Z",
    fill: "#C7CFE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_1926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreadmill);
export default __webpack_public_path__ + "static/media/treadmill.1a77a6154329a584d2df7186d2e5f746.svg";
export { ForwardRef as ReactComponent };